module.exports = __webpack_public_path__ + "img/Banner640ABC.a378c210.png";